import React, { Component } from 'react'; //different
//import './style.css';
import instance from "./axios-instance";
import Systems from "./SystemFunction";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
var settings = {
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 3000,
    cssEase: "linear",

    centerMode: false,      // ❌ ปิด
    centerPadding: "0px",   // ❌ ไม่ต้องมี
};



var settingsx = {
    dots: false, // ซ่อนจุดนำทาง
    infinite: true, // วนลูป slides
    slidesToShow: 6, // แสดง 6 slides
    slidesToScroll: 1, // เลื่อนทีละ 1 slide
    autoplay: true, // autoplay
    speed: 2000, // ความเร็วในการเลื่อน (ms)
    autoplaySpeed: 3000, // ช่วงเวลาระหว่าง autoplay
    cssEase: "linear", // ความเรียบเนียนของ transition
    centerMode: false, // ไม่ต้องแสดง slide ตรงกลาง
    centerPadding: "0px", // ระยะห่างซ้าย-ขวาของ slides
    responsive: [
        {
            breakpoint: 768, // สำหรับมือถือ
            settings: {
                slidesToShow: 3, // แสดง 3 slides
            }
        },
        {
            breakpoint: 480, // สำหรับหน้าจอเล็กสุด
            settings: {
                slidesToShow: 1, // แสดง 1 slide
            }
        }
    ]
};


class Bannerin extends Component {
    constructor(props) {
        super(props)
        this.state = {
            tabbannerlist: [],
            type: 1
        }

    }
    componentDidMount() {
        const { type } = this.props;  // รับค่า type
        const cacheKey = "tabBannerListCache";
        const cacheTTL = 3 * 60 * 60 * 1000; // 3 ชั่วโมงในมิลลิวินาที
        const cachedData = JSON.parse(localStorage.getItem(cacheKey));

        // ตรวจสอบแคช
        if (cachedData && (Date.now() - cachedData.timestamp < cacheTTL)) {
            console.log("Using cached data for tabbannerlist", cachedData.data);
            this.setState({ tabbannerlist: cachedData.data, type });
        } else {
            // ถ้าไม่มีแคชหรือแคชหมดอายุ ให้เรียก API
            instance.get("/api/v1/tabbannerlist?System=" + Systems)
                .then((res) => {
                    console.log("tabbannerlist", res.data);
                    if (res.data.status === 200) {
                        this.setState({ tabbannerlist: res.data.message, type });

                        // บันทึกข้อมูลลงในแคช
                        localStorage.setItem(cacheKey, JSON.stringify({
                            timestamp: Date.now(),
                            data: res.data.message,
                        }));
                    }
                }).catch((err) => {
                    console.error("Error fetching tabbannerlist:", err);
                });
        }
        this.promotionlist()


    }
    promotionlist = (typepromotion = 0) => {
        console.log("promotionlist", typepromotion);

        // เช็คแคชของ promotionlist
        const cacheKey = "promotionCacheKey";
        const cacheTTL = 3 * 60 * 60 * 1000; // 3 ชั่วโมงในมิลลิวินาที
        const cachedData = JSON.parse(localStorage.getItem(cacheKey));

        if (cachedData && (Date.now() - cachedData.timestamp < cacheTTL)) {
            console.log("Using cached data for promotions", cachedData.data);
            this.setState({ prolistx: cachedData.data, loadingPromo: false });
        } else {
            // ถ้าไม่มีแคชหรือแคชหมดอายุ ให้เรียก API ใหม่
            console.log("Fetching new promotion data");
            this.setState({ loadingPromo: true });
            instance
                .post("/api/v1/getpromotion", {
                    System: Systems,
                    typepromotion: typepromotion, // 0=all,1=new,2=daily,3=special,4=cashback
                })
                .then((res) => {
                    if (res.data.status === 200) {
                        this.setState({
                            prolistx: res.data.message || [],
                            loadingPromo: false,
                        });

                        // บันทึกข้อมูลลงในแคช
                        localStorage.setItem(cacheKey, JSON.stringify({
                            timestamp: Date.now(),
                            data: res.data.message,
                        }));
                    } else {
                        this.setState({ prolistx: [], loadingPromo: false });
                    }
                })
                .catch(async (err) => {
                    console.log(err);
                    this.setState({ loadingPromo: false });

                    if (err.response?.status === 401 || err.response?.status === 403) {
                        localStorage.clear();
                        await this.notify(
                            "warning",
                            "Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง"
                        );
                    }
                });
        }
    };


    render() {
        const { tabbannerlist, type, prolistx } = this.state;
        console.log("prolistx", type)
        return (
            <>
                {type === 1 ? (
                    <div
                        className="elementor-element elementor-element-41de999 elementor-grid-1 elementor-grid-tablet-1 elementor-pagination-position-inside elementor-posts--thumbnail-top elementor-grid-mobile-1 elementor-widget elementor-widget-posts e-widget-swiper"
                        data-id="41de999"
                        data-element_type="widget"
                        data-settings='{"custom_post_slider":"yes","custom_columns":"1","custom_columns_tablet":"1","custom_slides_to_show":"1","custom_row_gap":{"unit":"px","size":0,"sizes":[]},"custom_slide_gap":{"unit":"px","size":0,"sizes":[]},"custom_row_gap_mobile":{"unit":"px","size":0,"sizes":[]},"custom_navigation":"both","custom_columns_mobile":"1","custom_row_gap_tablet":{"unit":"px","size":"","sizes":[]},"custom_pause_on_hover":"yes","custom_autoplay":"yes","custom_autoplay_speed":5000,"custom_infinite":"yes","custom_speed":500,"custom_direction":"ltr"}'
                        data-widget_type="posts.custom"
                    >
                        <div className="elementor-widget-container">
                            <div className="elementor-main-swiper swiper-container swiper swiper-initialized swiper-horizontal swiper-pointer-events">
                                <div
                                    className="ecs-posts elementor-posts-container elementor-posts swiper-wrapper elementor-posts--skin-custom"
                                    data-settings='{"current_page":1,"max_num_pages":1,"load_method":"","widget_id":"41de999","post_id":16563,"theme_id":16563,"change_url":false,"reinit_js":false}'
                                    id="swiper-wrapper-769366ecad1036c2a"
                                    aria-live="off"
                                ></div>
                                <Slider {...settings}>
                                    {tabbannerlist && tabbannerlist.length > 0
                                        ? tabbannerlist.map((item, index) => {
                                            const postId = item.id || `post-${index}`;
                                            const imgSrc = item.path || item.src || '';
                                            const altText = item.alt || item.title || 'banner';

                                            return (
                                                <article
                                                    key={postId}
                                                    id={`post-${postId}`}
                                                    className="elementor-post elementor-grid-item ecs-post-loop swiper-slide"
                                                    data-swiper-slide-index={index}
                                                    role="group"
                                                    aria-label={`Slide ${index + 1} of ${tabbannerlist.length}`}
                                                >
                                                    <div
                                                        data-elementor-type="loop"
                                                        className="elementor elementor-3493 elementor-location-single"
                                                        data-elementor-post-type="elementor_library"
                                                    >
                                                        <div className="elementor-element elementor-element-60efb584 e-con-full e-flex e-con">
                                                            {/* Mobile image */}
                                                            <div className="elementor-element elementor-element-306ca140 mobile-768 dce_masking-none elementor-widget elementor-widget-image">
                                                                <div className="elementor-widget-container">
                                                                    <a href="/login">
                                                                        <img
                                                                            width={1024}
                                                                            height={500}
                                                                            decoding="async"
                                                                            src={imgSrc}
                                                                            alt={altText}
                                                                            data-lazy-src={imgSrc}
                                                                            style={{ width: '100%', height: 'auto' }}
                                                                        />
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </article>
                                            );
                                        })
                                        : null}
                                </Slider>
                            </div>
                        </div>{" "}
                    </div>
                ) : (
                    
                    <div className="snaplist overflow-x-auto flex gap-[10px] py-2  scrollbar-thin scrollbar-track-transparent scrollbar-thumb-gray-500/50 hover:scrollbar-thumb-orange-500/60 scrollbar-thumb-rounded-full">
                        <Slider {...settingsx}>
                            {this.state.prolistx && this.state.prolistx.length > 0
                                ? this.state.prolistx.map((item, index) => {
                                    const postId = item.id || `post-${index}`;
                                    const imgSrc = item.imagesec || '';
                                    const altText = item.alt || item.title || 'banner';

                                    return (
                                        <div className="slick-slide specific-slide" style={{ width: '147px', height: '147px' }}>
                                            <div key={postId} className="w-[147px] h-[147px] flex-shrink-0 flex flex-col cursor-pointer">
                                                <div className="relative rounded-t-md overflow-hidden w-[147px] h-[147px]">
                                                    <img src={imgSrc} alt={altText} className="object-cover w-full h-full" />
                                                </div>
                                                <div className="flex justify-center items-center Promotion_bgButton__X9s6S h-[20px]">
                                                    <div className="text-center font-[700] text-[#F5F5F5] leading-[13px] text-[11px]">รายละเอียดกิจกรรม</div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })
                                : null}
                        </Slider>
                    </div >
                )
                }

            </>
        );
    }
}
export default Bannerin;
